import { useContext } from 'react'
import { CreditsContext, type CreditsContextValue } from './creditsContextCore'

export const useCredits = (): CreditsContextValue => {
  const context = useContext(CreditsContext)
  if (!context) throw new Error('useCredits must be used within CreditsProvider')
  return context
}

/** Safe variant for surfaces mounted outside the provider (e.g. public site).
 * Returns null instead of throwing so callers can gracefully fall back. */
export const useOptionalCredits = (): CreditsContextValue | null => {
  const context = useContext(CreditsContext)
  return context ?? null
}
